import Vue from 'vue'
import TIM from 'tim-js-sdk'

const TIM_CUSTOM_SYSTEM_TYPES = {
  LIVE_ROOM_END: 'liveroomEnd', // 直播结束
  MUTE_ALL: 'shutUpAllMember', // 全局禁言的系统消息类型
  FORBID_SOMEONE: 'forbidSendMsg', // 某人被禁言了
  QESTION_SWITCH: 'liveroomAnswerSwitchChange', // 开关用户提问
  QUESTION_ADDED: 'liveroomUserQuestionAdded', // 新增用户提问
  QUESTION_REFUESED: 'liveroomQueueRefused', // 用户提问被打回的事件类型
  QUESTION_EXPLAIN_START: 'liveroomQueueStartExplain', // 开始讲解用户提问事件类型
  QUESTION_EXPLAIN_COMPLETE: 'liveroomQueueExplainComplete', // 完成讲解事件类型
  MESSAGE_DELETED: 'liveroomChatContentDelete'
}
console.log(TIM_CUSTOM_SYSTEM_TYPES)
const TimEventBus = new Vue({
  data() {
    return {
      tim: null
    }
  },
  methods: {
    emitMessage(message) {
      console.log('emitMessage', message)
      if (message.type === TIM.TYPES.MSG_TEXT) {
        this.$emit('MSG_TEXT', message)
      }
      if (message.type === TIM.TYPES.MSG_GRP_SYS_NOTICE) {
        this.$emit('MSG_GRP_SYS_NOTICE', message)
        // 系统消息分发
        const d = message.payload.userDefinedField
        if (d) {
          const j = JSON.parse(d)
          this.$emit(j.type, j.data, j, message)
        }
      }
      if (message.type === 'SDK_READY') {
        this.$emit('SDK_READY', message)
      }
    },
    initTim(SDKAppID) {
      // 创建 SDK 实例，TIM.create() 方法对于同一个 SDKAppID 只会返回同一份实例
      const options = {
        SDKAppID // 接入时需要将0替换为您的即时通信应用的 SDKAppID
      }
      const tim = TIM.create(options) // SDK 实例通常用 tim 表示
      // 设置 SDK 日志输出级别，详细分级请参考 setLogLevel 接口的说明
      tim.setLogLevel(4) // 普通级别，日志量较多，接入时建议使用

      tim.on(TIM.EVENT.SDK_READY, (event) => {
        // SDK ready 后接入侧才可以调用 sendMessage 等需要鉴权的接口，否则会提示失败！
        // event.name - TIM.EVENT.SDK_READY
        this.emitMessage({ type: 'SDK_READY' })
        // dispatch('handleTIMReady', event)
      })

      tim.on(TIM.EVENT.MESSAGE_RECEIVED, (event) => {
        // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
        // event.name - TIM.EVENT.MESSAGE_RECEIVED
        // event.data - 存储 Message 对象的数组 - [Message]
        const length = event.data.length
        let message
        for (let i = 0; i < length; i++) {
          // Message 实例的详细数据结构请参考 Message
          // 其中 type 和 payload 属性需要重点关注
          // 从v2.6.0起，AVChatRoom 内的群聊消息，进群退群等群提示消息，增加了 nick（昵称） 和 avatar（头像URL） 属性，便于接入侧做体验更好的展示
          // 前提您需要先调用 updateMyProfile 设置自己的 nick（昵称） 和 avatar（头像 URL），请参考 updateMyProfile 接口的说明
          message = event.data[i]
          this.emitMessage(message)
        }
      })
      this.tim = tim
      return tim
    },
    async loginTim({ userSig, userID, groupID }) {
      const tim = this.tim
      if (!tim) return
      await tim.login({ userID, userSig })
      /**
       * imResponse.data.status:
       *  TIM.TYPES.JOIN_STATUS_SUCCESS // 加群成功 ->  imResponse.data.group // 加入的群组资料
       *  TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP // 已经在群中
       */
      if (groupID) {
        await this.timJoinGroup(groupID)
      }
    },
    async timJoinGroup(groupID) {
      const tim = this.tim
      if (!tim) return
      const imResponse = await tim.joinGroup({ groupID })
      this.$emit('SET_DATA_GROUP_LOGINED', imResponse.data.group)
      return imResponse
    }
  }
})
export default TimEventBus
